import * as History from 'history';

export default class RouterService {

	private static instance: RouterService;

	private constructor() {

	}

	public static getInstance(): RouterService {
		if (RouterService.instance === undefined) {
			RouterService.instance = new RouterService();
		}
		return RouterService.instance;
	}

	/**
	 * Forces a route push.
	 * @param params
	 */
	public forceRoute(path: string, history: History.History): void {
		// push the passed in link value to react-router.
		history.push(path);
	}



};